import { t as e } from "./utils-DQJjwn-K.js";
import { d as t } from "./dropdown-menu-Bt4mgeUb.js";
import "react";
import { AlertCircle as n, CheckCircle2 as r, Info as i, TriangleAlert as a, X as o } from "lucide-react";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
import { useTranslation as l } from "react-i18next";
//#region src/components/ui/input.tsx
function u({ className: t, type: n, ...r }) {
	return /* @__PURE__ */ s("input", {
		type: n,
		"data-slot": "input",
		className: e("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[length:var(--focus-ring-width)]", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", t),
		...r
	});
}
//#endregion
//#region src/components/ui/banner.tsx
var d = {
	error: {
		container: "border-destructive/30 bg-destructive/5",
		text: "text-destructive",
		icon: "text-destructive",
		hover: "hover:bg-destructive/10 hover:text-destructive"
	},
	warning: {
		container: "border-warning/30 bg-warning/5",
		text: "text-warning-text",
		icon: "text-warning",
		hover: "hover:bg-warning/10 hover:text-warning-text"
	},
	success: {
		container: "border-success/30 bg-success/5",
		text: "text-success-text",
		icon: "text-success",
		hover: "hover:bg-success/10 hover:text-success-text"
	},
	info: {
		container: "border-border bg-muted/40",
		text: "text-foreground",
		icon: "text-muted-foreground",
		hover: "hover:bg-muted"
	}
}, f = {
	error: n,
	warning: a,
	success: r,
	info: i
};
function p({ children: n, variant: r = "info", onDismiss: i, dismissLabel: a = "Dismiss", className: l }) {
	let u = d[r], p = f[r], m = r === "error" || r === "warning";
	return /* @__PURE__ */ c("div", {
		role: m ? "alert" : "status",
		"aria-live": m ? "assertive" : "polite",
		className: e("flex items-center gap-3 rounded-md border px-3 py-2 text-sm", u.container, l),
		children: [
			/* @__PURE__ */ s(p, { className: e("h-4 w-4 shrink-0", u.icon) }),
			/* @__PURE__ */ s("div", {
				className: e("min-w-0 flex-1", u.text),
				children: n
			}),
			i && /* @__PURE__ */ c(t, {
				variant: "ghost",
				size: "icon-sm",
				className: e("shrink-0", u.text, u.hover),
				onClick: i,
				children: [/* @__PURE__ */ s(o, { className: "h-4 w-4" }), /* @__PURE__ */ s("span", {
					className: "sr-only",
					children: a
				})]
			})
		]
	});
}
//#endregion
//#region src/components/skills/raw-file-editor.tsx
function m({ value: e, onChange: t }) {
	let { t: n } = l();
	return /* @__PURE__ */ s("textarea", {
		value: e,
		spellCheck: !1,
		placeholder: n("skills.detail.edit.editorPlaceholder"),
		className: h,
		onChange: (e) => {
			t(e.target.value);
		}
	});
}
var h = e("min-h-[420px] w-full resize-y rounded-lg border border-border bg-background p-3", "font-mono text-xs leading-relaxed", "outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring");
//#endregion
export { p as n, u as r, m as t };

//# sourceMappingURL=raw-file-editor-D75U563f.js.map